function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import RootRef from "@material-ui/core/RootRef";
import React, { Component } from "react";
import { replaceWith, toHHMMSS } from "@common/services/helpers";
import { KEY_ARROW_DOWN, KEY_ARROW_LEFT, KEY_ARROW_RIGHT, KEY_ARROW_UP, KEY_ENTER, KEY_SPACE, MIN_HD_RESOLUTION, MIN_RESOLUTION, SUBTITLE_OFF_ID, TIME_TO_SHARE } from "@config/constants";
var langs = require("langs");
var availableLanguages = langs.all();
var SettingsList = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(SettingsList, Component);
    var _super = _create_super(SettingsList);
    function SettingsList(props) {
        _class_call_check(this, SettingsList);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isNavigationListActive: false,
            isSettingListActive: false,
            isQualityListActive: false,
            isAudioListActive: false,
            isShareListActive: false,
            isSubtitleListActive: false,
            isListOpenedFromKeyboard: false,
            isQualityListClosedFromKeyboard: false
        };
        _this.shareButton = null;
        _this.qualityButton = /*#__PURE__*/ React.createRef();
        _this.audioButton = /*#__PURE__*/ React.createRef();
        _this.autoButton = /*#__PURE__*/ React.createRef();
        _this.subtitleButton = /*#__PURE__*/ React.createRef();
        _this.qualityList = /*#__PURE__*/ React.createRef();
        _this.audioList = /*#__PURE__*/ React.createRef();
        _this.subtitleList = /*#__PURE__*/ React.createRef();
        _this.changeQuality = _this.changeQuality.bind(_assert_this_initialized(_this));
        _this.changeAudioTrack = _this.changeAudioTrack.bind(_assert_this_initialized(_this));
        _this.changeSubtitleTrack = _this.changeSubtitleTrack.bind(_assert_this_initialized(_this));
        _this.showQualityList = _this.showQualityList.bind(_assert_this_initialized(_this));
        _this.showSettingsList = _this.showSettingsList.bind(_assert_this_initialized(_this));
        _this.showAudioList = _this.showAudioList.bind(_assert_this_initialized(_this));
        _this.showSubtitleList = _this.showSubtitleList.bind(_assert_this_initialized(_this));
        _this.showNavigationList = _this.showNavigationList.bind(_assert_this_initialized(_this));
        _this.showShareList = _this.showShareList.bind(_assert_this_initialized(_this));
        _this.toggleList = _this.toggleList.bind(_assert_this_initialized(_this));
        _this.openListFromKeyboard = _this.openListFromKeyboard.bind(_assert_this_initialized(_this));
        _this.navigateList = _this.navigateList.bind(_assert_this_initialized(_this));
        _this.share = _this.share.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(SettingsList, [
        {
            key: "componentWillUpdate",
            value: function componentWillUpdate(param) {
                var isOpenSettingsList = param.isOpenSettingsList, isOpenShareList = param.isOpenShareList;
                if (isOpenSettingsList !== this.props.isOpenSettingsList) {
                    if (this.props.screenType.web) {
                        this.showSettingsList();
                    } else {
                        this.showNavigationList();
                    }
                }
                if (isOpenShareList !== this.props.isOpenShareList) {
                    this.showShareList();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpenShareList !== prevProps.isOpenShareList && this.props.isShareListToggledFromKeyboard && this.shareButton) {
                    this.shareButton.focus();
                }
                if (this.props.isOpenSettingsList !== prevProps.isOpenSettingsList && this.props.isOpenSettingsList && this.props.isSettingsListToggledFromKeyboard || this.state.isQualityListClosedFromKeyboard) {
                    if (this.audioButton && this.qualityButton) {
                        this.props.videoPlayer.video.audioTracks.length > 1 ? this.audioButton.focus() : this.qualityButton.focus();
                        this.setState({
                            isQualityListClosedFromKeyboard: false
                        });
                    }
                }
                if (this.state.isQualityListActive !== prevState.isQualityListActive && this.state.isQualityListActive && this.state.isListOpenedFromKeyboard) {
                    this.qualityList.children[1].focus();
                    this.setState({
                        isListOpenedFromKeyboard: false
                    });
                }
                if (this.state.isAudioListActive !== prevState.isAudioListActive && this.state.isAudioListActive && this.state.isListOpenedFromKeyboard) {
                    this.audioList.children[1].focus();
                    this.setState({
                        isListOpenedFromKeyboard: false
                    });
                }
                if (this.state.isSubtitleListActive !== prevState.isSubtitleListActive && this.state.isSubtitleListActive && this.state.isListOpenedFromKeyboard) {
                    this.subtitleList.children[1].focus();
                    this.setState({
                        isListOpenedFromKeyboard: false
                    });
                }
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, isOpenSettingsList = _this_props.isOpenSettingsList, isOpenShareList = _this_props.isOpenShareList;
                return nextProps.videoPlayer.video.levels !== videoPlayer.video.levels || nextProps.videoPlayer.video.currentLevel !== videoPlayer.video.currentLevel || nextProps.videoPlayer.video.autoLevel !== videoPlayer.video.autoLevel || nextProps.videoPlayer.video.audioTracks !== videoPlayer.video.audioTracks || nextProps.videoPlayer.video.currentAudioTrack !== videoPlayer.video.currentAudioTrack || nextProps.videoPlayer.video.subtitleTracks !== videoPlayer.video.subtitleTracks || nextProps.videoPlayer.video.currentSubtitleTrack !== videoPlayer.video.currentSubtitleTrack || nextProps.isOpenSettingsList !== isOpenSettingsList || nextProps.isOpenShareList !== isOpenShareList || nextProps.videoPlayer.video.shareTime !== videoPlayer.video.shareTime || nextState !== this.state;
            }
        },
        {
            /**
     * Change quality of video
     * @param event
     * @param value {number}
     */ key: "changeQuality",
            value: function changeQuality(event, value) {
                event.stopPropagation();
                var actions = this.props.actions;
                actions.changeQuality(value);
            }
        },
        {
            /**
     * Method responsible for sharing video snippet to facebook
     * @param event
     */ key: "share",
            value: function share(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    event.stopPropagation();
                // TODO add share functionality ???
                }
            }
        },
        {
            /**
     * Change audio track
     * @param event
     * @param value {number}
     */ key: "changeAudioTrack",
            value: function changeAudioTrack(event, value) {
                event.stopPropagation();
                var actions = this.props.actions;
                actions.changeAudioTrack(value);
            }
        },
        {
            /**
     * Change subtitle track
     * @param event
     * @param value {number}
     */ key: "changeSubtitleTrack",
            value: function changeSubtitleTrack(event, value) {
                event.stopPropagation();
                var actions = this.props.actions;
                actions.changeSubtitleTrack(value);
            }
        },
        {
            /**
     * Show navigation list
     */ key: "showNavigationList",
            value: function showNavigationList(event) {
                if (event) {
                    event.stopPropagation();
                }
                this.setState(function() {
                    return {
                        isNavigationListActive: true,
                        isSettingListActive: false,
                        isQualityListActive: false,
                        isAudioListActive: false,
                        isSubtitleListActive: false,
                        isShareListActive: false
                    };
                });
            }
        },
        {
            /**
     * Show quality list
     */ key: "showQualityList",
            value: function showQualityList(event) {
                event.stopPropagation();
                this.setState(function() {
                    return {
                        isNavigationListActive: false,
                        isSettingListActive: false,
                        isQualityListActive: true,
                        isAudioListActive: false,
                        isSubtitleListActive: false,
                        isShareListActive: false
                    };
                });
                this.qualityList.focus();
            }
        },
        {
            /**
     * Opens the settings list from keyboard
     * @params event {Object}
     * @params buttonRef {DomElement}
     */ key: "openListFromKeyboard",
            value: function openListFromKeyboard(event, buttonRef) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER || key === KEY_ARROW_RIGHT) {
                    if (buttonRef === this.qualityButton) {
                        this.showQualityList(event);
                        this.setState({
                            isListOpenedFromKeyboard: true
                        });
                    }
                    if (buttonRef === this.audioButton) {
                        this.showAudioList(event);
                        this.setState({
                            isListOpenedFromKeyboard: true
                        });
                    }
                    if (buttonRef === this.subtitleButton) {
                        this.showSubtitleList(event);
                        this.setState({
                            isListOpenedFromKeyboard: true
                        });
                    }
                }
            }
        },
        {
            /**
     * Show audio list
     */ key: "showAudioList",
            value: function showAudioList(event) {
                event.stopPropagation();
                this.setState(function() {
                    return {
                        isNavigationListActive: false,
                        isSettingListActive: false,
                        isQualityListActive: false,
                        isAudioListActive: true,
                        isSubtitleListActive: false,
                        isShareListActive: false
                    };
                });
                this.audioList.focus();
            }
        },
        {
            /**
     * Show subtitle list
     */ key: "showSubtitleList",
            value: function showSubtitleList(event) {
                event.stopPropagation();
                this.setState(function() {
                    return {
                        isNavigationListActive: false,
                        isSettingListActive: false,
                        isQualityListActive: false,
                        isAudioListActive: false,
                        isSubtitleListActive: true,
                        isShareListActive: false
                    };
                });
                this.subtitleList.focus();
            }
        },
        {
            /**
     * Method responsible for the keyboard navigation
     * in the menu
     * @params {event} {DomElement}
     */ key: "navigateList",
            value: function navigateList(event, listRef) {
                var key = event.which;
                if (key === KEY_ARROW_LEFT) {
                    event.stopPropagation();
                    this.showSettingsList(event);
                    this.setState({
                        isQualityListClosedFromKeyboard: true
                    });
                }
                if (key === KEY_ARROW_UP || key === KEY_ARROW_DOWN) {
                    event.stopPropagation();
                    var listItems = listRef.children;
                    var focusedElementIndex = null;
                    Array.prototype.forEach.call(listItems, function(item, index) {
                        if (document.activeElement === item) {
                            focusedElementIndex = index;
                        }
                    });
                    if (key === KEY_ARROW_UP) {
                        if (listRef === this.settingsList && focusedElementIndex > 0) {
                            listItems[focusedElementIndex - 1].focus();
                        }
                        if (listRef !== this.settingsList && focusedElementIndex > 1) {
                            listItems[focusedElementIndex - 1].focus();
                        }
                    }
                    if (focusedElementIndex < listItems.length - 1 && key === KEY_ARROW_DOWN) {
                        listItems[focusedElementIndex + 1].focus();
                    }
                }
            }
        },
        {
            /**
     * Show settings list
     */ key: "showSettingsList",
            value: function showSettingsList(event) {
                if (event) {
                    event.stopPropagation();
                }
                this.setState(function() {
                    return {
                        isNavigationListActive: false,
                        isSettingListActive: true,
                        isQualityListActive: false,
                        isAudioListActive: false,
                        isSubtitleListActive: false,
                        isShareListActive: false
                    };
                });
            }
        },
        {
            key: "showShareList",
            value: function showShareList(event) {
                if (event) {
                    event.stopPropagation();
                }
                this.setState(function() {
                    return {
                        isNavigationListActive: false,
                        isSettingListActive: false,
                        isQualityListActive: false,
                        isAudioListActive: false,
                        isSubtitleListActive: false,
                        isShareListActive: true
                    };
                });
            }
        },
        {
            /**
     * Toggle global settings wrapper
     */ key: "toggleList",
            value: function toggleList() {
                var _this_props = this.props, isOpenSettingsList = _this_props.isOpenSettingsList, isOpenShareList = _this_props.isOpenShareList, actions = _this_props.actions;
                if (isOpenSettingsList) {
                    actions.toggleSettingsList();
                } else if (isOpenShareList) {
                    actions.toggleShareList();
                }
            }
        },
        {
            /**
     * Returns the name corresponding to the iso639-2 language code (uses the 'langs' library)
     */ key: "getLanguageName",
            value: function getLanguageName(langCode) {
                var langNameIndex = availableLanguages.findIndex(function(element) {
                    return element["2B"] === langCode;
                });
                return availableLanguages[langNameIndex] ? availableLanguages[langNameIndex].local : langCode;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, video = _this_props.videoPlayer.video, isOpenSettingsList = _this_props.isOpenSettingsList, isOpenShareList = _this_props.isOpenShareList, actions = _this_props.actions, i18n = _this_props.i18n, screenType = _this_props.screenType;
                var template = null;
                var qualityListItemsTabIndex = this.state.isQualityListActive ? "0" : "-1";
                var audioListItemsTabIndex = this.state.isAudioListActive ? "0" : "-1";
                var subtitleListItemsTabIndex = this.state.isSubtitleListActive ? "0" : "-1";
                var startTime = video.shareTime ? '<span class="values">'.concat(toHHMMSS(video.shareTime), "</span>") : 0;
                var endTime = video.shareTime ? '<span class="values">'.concat(toHHMMSS(video.shareTime + TIME_TO_SHARE), "</span>") : 0;
                var shareTemplate = video.shareTime ? replaceWith(i18n.player.shareSubText, [
                    startTime,
                    endTime
                ]) : null;
                if (video.levels) {
                    var currentLevel = video.currentLevel !== undefined ? video.currentLevel : 0;
                    var isHD = video.levels[currentLevel] && video.levels[currentLevel].height > MIN_HD_RESOLUTION;
                    var audioName = video.currentAudioTrack >= 0 && (this.getLanguageName(video.audioTracks[video.currentAudioTrack].name) || "".concat(i18n.player.audio, " ").concat(video.currentAudioTrack + 1));
                    template = /*#__PURE__*/ _jsx("div", {
                        className: "settings-wrapper".concat(isOpenSettingsList || isOpenShareList ? " active" : ""),
                        onClick: this.toggleList,
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "lists",
                            children: [
                                screenType.tablet || screenType.mobile ? /*#__PURE__*/ _jsxs(List, {
                                    component: "div",
                                    className: "navigation-list".concat(this.state.isNavigationListActive ? " active" : ""),
                                    children: [
                                        /*#__PURE__*/ _jsxs(ListItem, {
                                            button: true,
                                            onClick: function(event) {
                                                return _this.showSettingsList(event);
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "label",
                                                    children: i18n.player.settings
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-keyboard-arrow-right"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ListItem, {
                                            button: true,
                                            onClick: function(event) {
                                                event.stopPropagation();
                                                actions.toggleSettingsList();
                                            },
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "value",
                                                children: i18n.common.close
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ _jsx(RootRef, {
                                    rootRef: function(node) {
                                        return _this.settingsList = node;
                                    },
                                    children: /*#__PURE__*/ _jsxs(List, {
                                        component: "div",
                                        onKeyDown: function(event) {
                                            return _this.navigateList(event, _this.settingsList);
                                        },
                                        className: "settings-list".concat(this.state.isSettingListActive ? " active" : ""),
                                        children: [
                                            video && video.audioTracks && video.audioTracks.length > 1 ? /*#__PURE__*/ _jsx(RootRef, {
                                                rootRef: function(node) {
                                                    return _this.audioButton = node;
                                                },
                                                children: /*#__PURE__*/ _jsxs(ListItem, {
                                                    button: true,
                                                    onKeyDown: function(event) {
                                                        return _this.openListFromKeyboard(event, _this.audioButton);
                                                    },
                                                    className: "list-item",
                                                    onClick: function(event) {
                                                        return _this.showAudioList(event);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "label",
                                                            children: i18n.player.audio
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "value",
                                                            children: [
                                                                audioName,
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "icon icon-keyboard-arrow-right"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ _jsxs(ListItem, {
                                                disabled: true,
                                                onClick: function(event) {
                                                    return event.stopPropagation();
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "label",
                                                        children: i18n.player.audio
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "value",
                                                        children: audioName
                                                    })
                                                ]
                                            }),
                                            video.subtitleTracks && video.subtitleTracks.length > 0 ? /*#__PURE__*/ _jsx(RootRef, {
                                                rootRef: function(node) {
                                                    return _this.subtitleButton = node;
                                                },
                                                children: /*#__PURE__*/ _jsxs(ListItem, {
                                                    button: true,
                                                    onKeyDown: function(event) {
                                                        return _this.openListFromKeyboard(event, _this.subtitleButton);
                                                    },
                                                    className: "list-item",
                                                    onClick: function(event) {
                                                        return _this.showSubtitleList(event);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "label",
                                                            children: i18n.player.subtitle
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "value",
                                                            children: [
                                                                video.currentSubtitleTrack >= 0 ? this.getLanguageName(video.subtitleTracks[video.currentSubtitleTrack].name) : null,
                                                                video.currentSubtitleTrack === SUBTITLE_OFF_ID ? i18n.player.subtitleOff : null,
                                                                video.subtitleTracks.length > 0 ? /*#__PURE__*/ _jsx("span", {
                                                                    className: "icon icon-keyboard-arrow-right"
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ _jsx(RootRef, {
                                                rootRef: function(node) {
                                                    return _this.subtitleButton = node;
                                                },
                                                children: /*#__PURE__*/ _jsxs(ListItem, {
                                                    disabled: true,
                                                    button: true,
                                                    onKeyDown: function(event) {
                                                        return _this.openListFromKeyboard(event, _this.subtitleButton);
                                                    },
                                                    className: "list-item",
                                                    onClick: function(event) {
                                                        return _this.showSubtitleList(event);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "label",
                                                            children: i18n.player.subtitle
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "value",
                                                            children: i18n.lack
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(RootRef, {
                                                rootRef: function(node) {
                                                    return _this.qualityButton = node;
                                                },
                                                children: /*#__PURE__*/ _jsxs(ListItem, {
                                                    button: true,
                                                    className: "list-item",
                                                    onKeyDown: function(event) {
                                                        return _this.openListFromKeyboard(event, _this.qualityButton);
                                                    },
                                                    onClick: function(event) {
                                                        return _this.showQualityList(event);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "label",
                                                            children: i18n.player.quality
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "value",
                                                            children: [
                                                                video.autoLevel ? i18n.player.autoShort + "(" : "",
                                                                video.levels[currentLevel] && video.levels[currentLevel].height || MIN_RESOLUTION,
                                                                "p",
                                                                isHD ? /*#__PURE__*/ _jsx("span", {
                                                                    className: "hd",
                                                                    children: "HD"
                                                                }) : null,
                                                                video.autoLevel ? ")" : "",
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "icon icon-keyboard-arrow-right"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            screenType.tablet || screenType.mobile ? /*#__PURE__*/ _jsx(ListItem, {
                                                button: true,
                                                onClick: function(event) {
                                                    return _this.showNavigationList(event);
                                                },
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "value",
                                                    children: i18n.player.back
                                                })
                                            }, -2) : null
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(RootRef, {
                                    rootRef: function(node) {
                                        return _this.qualityList = node;
                                    },
                                    children: /*#__PURE__*/ _jsxs(List, {
                                        component: "div",
                                        onKeyDown: function(event) {
                                            return _this.navigateList(event, _this.qualityList);
                                        },
                                        className: "quality-list".concat(this.state.isQualityListActive ? " active" : ""),
                                        children: [
                                            screenType.web ? /*#__PURE__*/ _jsxs(ListItem, {
                                                button: true,
                                                tabIndex: qualityListItemsTabIndex,
                                                onClick: function(event) {
                                                    return _this.showSettingsList(event);
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "icon icon-keyboard-arrow-right"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "value",
                                                        children: i18n.player.quality
                                                    })
                                                ]
                                            }, -2) : null,
                                            /*#__PURE__*/ _jsx(RootRef, {
                                                rootRef: function(node) {
                                                    _this.autoButton = node;
                                                },
                                                children: /*#__PURE__*/ _jsxs(ListItem, {
                                                    button: true,
                                                    tabIndex: qualityListItemsTabIndex,
                                                    className: "list-item ".concat(video.autoLevel ? "checked" : ""),
                                                    onClick: function(event) {
                                                        return _this.changeQuality(event, -1);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "label",
                                                            children: video.autoLevel ? /*#__PURE__*/ _jsx("span", {
                                                                className: "icon icon-done"
                                                            }) : null
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "value",
                                                            children: i18n.player.auto
                                                        })
                                                    ]
                                                }, -1)
                                            }),
                                            _to_consumable_array(video.levels).reverse().map(function(level) {
                                                return /*#__PURE__*/ _jsxs(ListItem, {
                                                    button: true,
                                                    tabIndex: qualityListItemsTabIndex,
                                                    className: "list-item ".concat(currentLevel === level.value && !video.autoLevel ? "checked" : ""),
                                                    onClick: function(event) {
                                                        return _this.changeQuality(event, level.value);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "label",
                                                            children: currentLevel === level.value && !video.autoLevel ? /*#__PURE__*/ _jsx("span", {
                                                                className: "icon icon-done"
                                                            }) : null
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "value",
                                                            children: [
                                                                "".concat(level.height, "p"),
                                                                level.height > MIN_HD_RESOLUTION ? /*#__PURE__*/ _jsx("span", {
                                                                    className: "hd",
                                                                    children: "HD"
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                }, level.value);
                                            }),
                                            screenType.tablet || screenType.mobile ? /*#__PURE__*/ _jsx(ListItem, {
                                                button: true,
                                                onClick: function(event) {
                                                    return _this.showSettingsList(event);
                                                },
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "value",
                                                    children: i18n.player.back
                                                })
                                            }, -2) : null
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(RootRef, {
                                    rootRef: function(node) {
                                        return _this.audioList = node;
                                    },
                                    children: /*#__PURE__*/ _jsxs(List, {
                                        component: "div",
                                        onKeyDown: function(event) {
                                            return _this.navigateList(event, _this.audioList);
                                        },
                                        className: "audio-list".concat(this.state.isAudioListActive ? " active" : ""),
                                        children: [
                                            screenType.web ? /*#__PURE__*/ _jsxs(ListItem, {
                                                button: true,
                                                tabIndex: audioListItemsTabIndex,
                                                onClick: function(event) {
                                                    return _this.showSettingsList(event);
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "icon icon-keyboard-arrow-right"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "value",
                                                        children: i18n.player.audio
                                                    })
                                                ]
                                            }, -1) : null,
                                            video.audioTracks ? _to_consumable_array(video.audioTracks).map(function(audioTrack) {
                                                return /*#__PURE__*/ _jsxs(ListItem, {
                                                    button: true,
                                                    tabIndex: audioListItemsTabIndex,
                                                    className: "list-item ".concat(video.currentAudioTrack === audioTrack.id ? "checked" : ""),
                                                    onClick: function(event) {
                                                        return _this.changeAudioTrack(event, audioTrack.id);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "label",
                                                            children: video.currentAudioTrack === audioTrack.id ? /*#__PURE__*/ _jsx("span", {
                                                                className: "icon icon-done"
                                                            }) : null
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "value",
                                                            children: _this.getLanguageName(audioTrack.name)
                                                        })
                                                    ]
                                                }, audioTrack.id);
                                            }) : null,
                                            screenType.tablet || screenType.mobile ? /*#__PURE__*/ _jsx(ListItem, {
                                                button: true,
                                                onClick: function(event) {
                                                    return _this.showSettingsList(event);
                                                },
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "value",
                                                    children: i18n.player.back
                                                })
                                            }, -2) : null
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(RootRef, {
                                    rootRef: function(node) {
                                        return _this.subtitleList = node;
                                    },
                                    children: /*#__PURE__*/ _jsxs(List, {
                                        component: "div",
                                        onKeyDown: function(event) {
                                            return _this.navigateList(event, _this.subtitleList);
                                        },
                                        className: "subtitle-list".concat(this.state.isSubtitleListActive ? " active" : ""),
                                        children: [
                                            screenType.web ? /*#__PURE__*/ _jsxs(ListItem, {
                                                button: true,
                                                tabIndex: subtitleListItemsTabIndex,
                                                onClick: function(event) {
                                                    return _this.showSettingsList(event);
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "icon icon-keyboard-arrow-right"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "value",
                                                        children: i18n.player.subtitle
                                                    })
                                                ]
                                            }, -1) : null,
                                            video.subtitleTracks ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs(ListItem, {
                                                        button: true,
                                                        tabIndex: subtitleListItemsTabIndex,
                                                        className: "list-item ".concat(video.currentSubtitleTrack === SUBTITLE_OFF_ID ? "checked" : ""),
                                                        onClick: function(event) {
                                                            return _this.changeSubtitleTrack(event, SUBTITLE_OFF_ID);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "label",
                                                                children: video.currentSubtitleTrack === SUBTITLE_OFF_ID ? /*#__PURE__*/ _jsx("span", {
                                                                    className: "icon icon-done"
                                                                }) : null
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "value",
                                                                children: i18n.player.subtitleOff
                                                            })
                                                        ]
                                                    }, SUBTITLE_OFF_ID),
                                                    _to_consumable_array(video.subtitleTracks).map(function(subtitleTrack) {
                                                        return /*#__PURE__*/ _jsxs(ListItem, {
                                                            button: true,
                                                            tabIndex: subtitleListItemsTabIndex,
                                                            className: "list-item ".concat(video.currentSubtitleTrack === subtitleTrack.id ? "checked" : ""),
                                                            onClick: function(event) {
                                                                return _this.changeSubtitleTrack(event, subtitleTrack.id);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "label",
                                                                    children: video.currentSubtitleTrack === subtitleTrack.id ? /*#__PURE__*/ _jsx("span", {
                                                                        className: "icon icon-done"
                                                                    }) : null
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "value",
                                                                    children: _this.getLanguageName(subtitleTrack.name)
                                                                })
                                                            ]
                                                        }, "".concat(subtitleTrack.id, "-").concat(subtitleTrack.name));
                                                    })
                                                ]
                                            }) : null,
                                            screenType.tablet || screenType.mobile ? /*#__PURE__*/ _jsx(ListItem, {
                                                button: true,
                                                onClick: function(event) {
                                                    return _this.showSettingsList(event);
                                                },
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "value",
                                                    children: i18n.player.back
                                                })
                                            }, -2) : null
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(List, {
                                    component: "div",
                                    className: "share-list".concat(this.state.isShareListActive ? " active" : ""),
                                    children: [
                                        /*#__PURE__*/ _jsxs(ListItem, {
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-share"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "title",
                                                    children: i18n.player.share
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "text",
                                                    children: [
                                                        " ",
                                                        i18n.player.shareText
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "sub-text",
                                                    dangerouslySetInnerHTML: {
                                                        __html: shareTemplate
                                                    }
                                                }),
                                                screenType.web ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "icon icon-facebook"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "share-button",
                                                            tabIndex: this.state.isShareListActive ? "0" : "-1",
                                                            onKeyDown: this.share,
                                                            ref: function(node) {
                                                                return _this.shareButton = node;
                                                            },
                                                            children: i18n.player.share
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }, 1),
                                        screenType.tablet || screenType.mobile ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(ListItem, {
                                                    button: true,
                                                    className: "share-button checked",
                                                    onClick: function(event) {
                                                        return _this.showNavigationList(event);
                                                    },
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "value",
                                                        children: i18n.player.share
                                                    })
                                                }, 2),
                                                /*#__PURE__*/ _jsx(ListItem, {
                                                    button: true,
                                                    onClick: function(event) {
                                                        return _this.showNavigationList(event);
                                                    },
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "value",
                                                        children: i18n.player.back
                                                    })
                                                }, 3)
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    });
                }
                return template;
            }
        }
    ]);
    return SettingsList;
}(Component);
export default SettingsList;
